import type { NormalizeOAS, OASModel, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/projects', 'post'>;
type ResponseBody = OASOutput<O, '/api/projects', 'post'>;

type Params = {
  name: string;
  sceneId?: number | null;
  settings?: OASModel<O, 'ProjectSettings'>;
  theme?: OASModel<O, 'Theme'>;
  homeOverview?: OASModel<O, 'HomeOverviewSettings'>;
  froalaEditors?: OASModel<O, 'FroalaEditors'>;
};

type Result = {
  id: number;
  guid: string;
  name: string;
  thumbnailUrl: string;
  tagGuids: string[];
};

export const createProjectFactory = (apiClient: ApiClient) => {
  const createProject = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/projects'].post(requestBody);
    if (response.status !== 200) {
      throw new Error('Error creating project');
    }

    const responseBody = await response.json();
    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        name: input.name,
        sceneId: input.sceneId ?? null,
        settings: input.settings ?? null,
        theme: input.theme ?? null,
        homeOverview: input.homeOverview ?? null,
        froalaEditors: input.froalaEditors ?? null,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response.id,
      guid: response.guid,
      name: response.name,
      thumbnailUrl: response.thumbnailUrl,
      tagGuids: response.tagGuids,
    };
  };

  return createProject;
};
